import React from 'react';

const CompletedSessionsModal = ({ isOpen, onClose, sessions = [] }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 backdrop-blur-sm">
      {/* Modal content */}
      <div className="w-full sm:max-w-md bg-white rounded-t-2xl sm:rounded-2xl shadow-xl p-4 sm:p-6 max-h-[90vh] overflow-y-auto animate-in slide-in-from-bottom duration-300">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg sm:text-2xl font-bold text-slate-800">Completed Sessions</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 transition-colors">
            <span className="sr-only">Close</span>
            <svg className="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        {sessions.length === 0 ? (
          <div className="text-center text-slate-400 py-12">
            <p className="text-base font-medium">No completed sessions found.</p>
          </div>
        ) : (
          <ul className="space-y-4">
            {sessions.map((session, idx) => (
              <li key={idx} className="bg-slate-50 rounded-xl p-4 flex flex-col gap-1 shadow-sm border border-slate-100">
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-slate-700 text-sm sm:text-base">{session.className}</span>
                  <span className="text-xs text-slate-400">{session.date}</span>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs font-bold text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded">{session.subjectName}</span>
                  {session.subjectCode && (
                    <span className="text-[10px] font-mono text-slate-500 bg-slate-100 px-1.5 py-0.5 rounded">{session.subjectCode}</span>
                  )}
                  {session.batchName && (
                    <span className="text-[10px] font-bold text-purple-700 bg-purple-50 px-1.5 py-0.5 rounded">{session.batchName}</span>
                  )}
                </div>
                <div className="flex items-center gap-2 mt-1 text-xs text-slate-500">
                  <span>Ended at: {session.classEndTime ? new Date(session.classEndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '-'}</span>
                  <span className="hidden sm:inline">|</span>
                  <span>{session.room || 'No Room'}</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CompletedSessionsModal;
